























































































































import BaseComponent from '@/core/base.component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'Services',
})
export default class Services extends BaseComponent {
  navbarHeight: any = 0;

  startQuestions(location?: string) {
    if (!location) location = 'header';
    this.$router.push('/question');
    this.$gtag.event(`go_to_question_${location}`, {
      description: '질문지로 이동',
    });
  }

  mounted() {
    const target = document.querySelector('.navbar');
    this.navbarHeight = target.getBoundingClientRect().height;
  }
}
